export enum FormPosition {
  header,
  body,
  footer,
  column1,
  column2,
  column3,
  column4,
  column5
}

export enum FormControlTypes {
  textbox,
  textboxMultiline,
  datePicker,
  dropdown,
  radioList,
  radio,
  checkboxList,
  checkbox,
  upload,
  group,
  lookup,
  treelookup,
  colorPicker,
  multiColumnsSelector,
  Button,
}

